import { connect } from "react-redux";

import { getGameById } from "domain/Game/selectors";
import { getCityForUser } from "domain/User/selectors";
import { updateGameData as updateGameDataForList } from "domain/GamesSearch/actions";
import { updateGameData as updateGameDataForPage } from "domain/Game/actions";

import Component from "./Component";
import { getGroups } from "domain/Groups/selectors";
import { updateGroupData } from "domain/Groups/actions";
import { updateGroupData as updateBlackList } from "domain/BlackLists/actions";
import { toArray } from "lib/converters";
import { isMobile } from "domain/Version/selectors";
import { getBlacklistsCollection } from "domain/BlackLists/selectors";

const mapStateToProps = (state, { gameId }) => {
    return {
        game: getGameById(state, gameId),
        city: getCityForUser(state),
        userGroups: toArray(getGroups(state)),
        blacklists: toArray(getBlacklistsCollection(state)),
        isMobile: isMobile(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateGameData: (id, gameData) => {
            dispatch(updateGameDataForList(id, gameData));
            dispatch(updateGameDataForPage(id, gameData));
        },
        updateGroupData: (...args) => {
            dispatch(updateGroupData(...args));
        },
        updateBlackList: (...args) => {
            dispatch(updateBlackList(...args));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
